"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4892],{

/***/ 25901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ QuestionHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(25662);
// EXTERNAL MODULE: ./components/iconify.tsx
var iconify = __webpack_require__(88096);
;// CONCATENATED MODULE: ./components/previous.tsx



function Previous(param) {
    var onClick = param.onClick, hasResults = param.hasResults;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        title: "Go to Previous Page",
        children: !hasResults ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* default */.Z, {
                icon: "akar-icons:chevron-left"
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                width: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: onClick,
                sx: {
                    fontFamily: "ABCDiaTypeRegular",
                    textTransform: "capitalize"
                },
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* default */.Z, {
                    icon: "akar-icons:chevron-left"
                }),
                children: "Go Back To Results"
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./components/logo.tsx




// @mui

// ----------------------------------------------------------------------
function Logo(_param) {
    var other = (0,_extends/* default */.Z)({}, _param);
    var fill = "#333033";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexGrow: 1
        }
    }, other), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: "https://www.thrivelab.com",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 172.67 34.81",
                width: "110px",
                height: "22px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "Layer_2",
                    "data-name": "Layer 2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        id: "Layer_1-2",
                        "data-name": "Layer 1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M10.91,31.14c-1.17,2.49-2.49,3.67-5.41,3.67C1.93,34.81.05,32.5.05,28L0,5.64c1-.09,2.78-.89,4.33-1.08V11h6.35v1.27H4.33v15.9c0,2.68.75,4.33,3,4.33a3.7,3.7,0,0,0,3.24-1.65Z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M30.91,30V19.33c0-4.19-2-6.59-5.6-6.59A7.07,7.07,0,0,0,19,16.23V30c0,2.3.14,3.62.94,4.47H13.69c.85-.85,1-2.17,1-4.47V8.23c0-2.31-.24-5.46-1.13-6.3C15.05,1.78,17.12.24,18.91,0V14.86a9.81,9.81,0,0,1,8-4.42c5.5,0,8.28,3.2,8.28,9.22V30c0,2.3.14,3.62,1,4.47H30c.8-.85.95-2.17.95-4.47"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M55.5,11.52l-1.18,2.82h0a3.66,3.66,0,0,0-3.52-2.25,6.8,6.8,0,0,0-6.26,4.13V30c0,2.3.14,3.62.94,4.47H39.22c.85-.85,1-2.17,1-4.47V15.57c0-2.26-.19-3.3-1-4.14a39.72,39.72,0,0,0,4.93-.57v4.47c1.51-3,3.91-4.89,7-4.89a8.8,8.8,0,0,1,4.38,1.08"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M64.94,34.48H58.55c.89-.85,1.08-2.17,1.08-4.47V15.47c0-2.3-.24-3.38-1.13-4.23,1.5-.1,3.62-.24,5.41-.47V30c0,2.3.19,3.62,1,4.47"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M64,4.23a2.63,2.63,0,0,1-5.26,0,2.63,2.63,0,0,1,5.26,0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M90.3,10.86a7,7,0,0,0-2.17,3.67L80.94,34.48h-4L69.69,14.63a7.34,7.34,0,0,0-2.35-3.77h6.21c-.85.94-.09,2.12.47,3.58l6.4,17.68,6.35-17.73c.52-1.46.7-2.78-.24-3.53Z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M95,21.31l13.32,0c-.19-6-2.26-9.92-6.26-9.92s-6.73,3.9-7.06,9.88m0,1.31c0,7.15,3.52,11,7.76,11a11.18,11.18,0,0,0,7.85-3.95h0l.89,1.88a15.09,15.09,0,0,1-9.45,3.3c-6.68,0-11.71-4.71-11.71-12.09,0-6.92,4.7-12.28,11.61-12.28s10.31,4.94,10.4,11.71v.42H94.91Z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M115.11,1.92c1.51-.14,3.62-1.68,5.41-1.92V30c0,2.3.19,3.62,1,4.47h-6.4c.89-.85,1.08-2.17,1.08-4.47V6.16c0-2.31-.23-3.39-1.13-4.24"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M140.7,30.2V24.83a7.54,7.54,0,0,0-5.5-2.26c-4.1,0-5.74,2.54-5.74,5.08,0,2.73,2.21,5,5.78,5a7.66,7.66,0,0,0,5.46-2.44m.38,4.28-.24-3.3a9.8,9.8,0,0,1-7.71,3.63c-4.57,0-7.86-2.73-7.86-6.92s3.34-7,8.61-7a10,10,0,0,1,6.82,2.64V19.09c0-4.37-1.32-7.52-6-7.52A9.55,9.55,0,0,0,127.86,15h0l-.7-2.3a14.42,14.42,0,0,1,8.23-2.26c7.15,0,9.59,3.86,9.59,9.41V30.57c0,2,.1,3.11.85,3.91Z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M168.24,22.72c0-6.78-2.82-10-7.19-10a8,8,0,0,0-6.4,4.1V28.12c1.55,2.83,4.28,4.38,6.4,4.38,4.42,0,7.19-3.25,7.19-9.78m4.43,0c0,7.48-3.77,12.09-9.88,12.09a8.5,8.5,0,0,1-8.14-5.27l-.42,4.94h-4.94c.89-.85,1.08-2.17,1.08-4.47V6.16c0-2.31-.19-3.39-1.08-4.23,1.5-.1,3.62-1.69,5.41-1.93l0,15.66a8.52,8.52,0,0,1,8.14-5.22c5.92,0,9.88,4.66,9.88,12.28"
                            })
                        ]
                    })
                })
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/header.tsx



// components


function QuestionHeader(param) {
    var onPrevious = param.onPrevious, hasResults = param.hasResults;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            height: "60px",
            background: "#F7F2E8",
            // flex: 1,
            flexGrow: 1,
            borderRadius: "0 0 16px 16px",
            width: "100%",
            // maxWidth: { xs: "100%", lg: "60%" },
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            mx: "auto",
            maxHeight: "64px",
            mb: 2
        },
        children: [
            onPrevious && /*#__PURE__*/ (0,jsx_runtime.jsx)(Previous, {
                onClick: onPrevious,
                hasResults: hasResults
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {})
        ]
    });
};


/***/ }),

/***/ 88096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Iconify; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5616);



// icons

// @mui

function Iconify(_param) {
    var icon = _param.icon, sx = _param.sx, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "icon",
        "sx"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        component: _iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO,
        icon: icon,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, sx)
    }, other));
};


/***/ }),

/***/ 62106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AX": function() { return /* binding */ cancelFreeConsult; },
/* harmony export */   "Jt": function() { return /* binding */ bookFreeConsult; },
/* harmony export */   "Ke": function() { return /* binding */ updateFreeConsult; },
/* harmony export */   "Pp": function() { return /* binding */ getFreeConsult; },
/* harmony export */   "Qo": function() { return /* binding */ useBookingContext; }
/* harmony export */ });
/* unused harmony exports checkMeeting, cancelBooking */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42309);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23855);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58545);
/* harmony import */ var _contexts_HVBContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58995);









// ==========================================================================================
var useBookingContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_HVBContext__WEBPACK_IMPORTED_MODULE_4__/* .BookingContext */ .z);
};
var bookFreeConsult = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var ref, payload, result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    payload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, params), {
                        utmCode: {
                            utm_campaign: params.utm_campaign,
                            utm_content: params.utm_content,
                            utm_medium: params.utm_medium,
                            utm_source: params.utm_source,
                            utm_term: params.utm_term
                        }
                    });
                    _ctx.next = 4;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat("https://api-auth.thrivelab.com/api", "/staff/book"), payload);
                case 4:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        isLoading: false,
                        // isError:
                        //   data?.zoho?.toLowerCase() !== "success!" ||
                        //   !data?.calId ||
                        //   status !== 201,
                        isError: (data === null || data === void 0 ? void 0 : data.zoho) && (data === null || data === void 0 ? void 0 : (ref = data.zoho) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || status !== 201
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function bookFreeConsult(params) {
        return _ref.apply(this, arguments);
    };
}();
var canCancelOrSched = function(data) {
    var ref = data !== null && data !== void 0 ? data : {
        Cancelation_and_Rescheduling_Window_Min: null,
        Start_DateTime: null
    }, cancelWindow = ref.Cancelation_and_Rescheduling_Window_Min, Start_DateTime = ref.Start_DateTime;
    if (!Start_DateTime) return true;
    var allowedDate = Start_DateTime ? (0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(Start_DateTime) : null;
    if (cancelWindow && Start_DateTime) {
        allowedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(Start_DateTime), -Number(cancelWindow));
    }
    if (!(data === null || data === void 0 ? void 0 : data.Cancelation_and_Rescheduling_Window_Min)) return true;
    else if (allowedDate) return new Date() < allowedDate;
    else return true;
};
var getFreeConsult = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("".concat("https://api-auth.thrivelab.com/api", "/calendar/").concat(id));
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data), {
                            canCancelOrResched: canCancelOrSched(data)
                        }),
                        isLoading: false,
                        status: status,
                        isError: status !== 200
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getFreeConsult(id) {
        return _ref.apply(this, arguments);
    };
}();
var updateFreeConsult = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var payload, result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    payload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, params), {
                        utmCode: {
                            utm_campaign: params.utm_campaign,
                            utm_content: params.utm_content,
                            utm_medium: params.utm_medium,
                            utm_source: params.utm_source,
                            utm_term: params.utm_term
                        }
                    });
                    _ctx.next = 3;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].put */ .Z.put("".concat("https://api-auth.thrivelab.com/api", "/staff/book"), payload);
                case 3:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        isLoading: false,
                        isError: data === null || status !== 200
                    });
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateFreeConsult(params) {
        return _ref.apply(this, arguments);
    };
}();
var cancelFreeConsult = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].put */ .Z.put("".concat("https://api-auth.thrivelab.com/api", "/staff/cancel"), params);
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data || {}), {
                        status: status,
                        isLoading: false,
                        isError: status !== 200 || data === ""
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function cancelFreeConsult(params) {
        return _ref.apply(this, arguments);
    };
}();
var checkMeeting = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(email) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_3___default().get("/api/check-booking/?email=".concat(email));
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data || {}), {
                        status: status,
                        isLoading: false,
                        isError: status !== 200
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function checkMeeting(email) {
        return _ref.apply(this, arguments);
    };
}();
var cancelBooking = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(bookingId) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_3___default().post("/api/cancel-booking", {
                        booking_id: bookingId
                    });
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data || {}), {
                        status: status,
                        isLoading: false,
                        isError: status !== 200
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function cancelBooking(bookingId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 13768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U2": function() { return /* binding */ getServices; },
/* harmony export */   "mR": function() { return /* binding */ getWorkspaceService; }
/* harmony export */ });
/* unused harmony exports generateToken, getPatientServices, getPatientInfo, getWorkspaces */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);


var generateToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(patientid) {
        var authPath, payload, result;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    authPath = "".concat("https://api-auth.thrivelab.com/api", "/auth/medication");
                    payload = {
                        patientId: patientid !== null && patientid !== void 0 ? patientid : "390855083",
                        providerId: "390855083",
                        secret: "FRKWb6*0j2Xa"
                    };
                    _ctx.next = 5;
                    return fetch(authPath, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(payload)
                    });
                case 5:
                    result = _ctx.sent;
                    _ctx.next = 8;
                    return result.json();
                case 8:
                    return _ctx.abrupt("return", _ctx.sent);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.warn(_ctx.t0);
                    return _ctx.abrupt("return", undefined);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function generateToken(patientid) {
        return _ref.apply(this, arguments);
    };
}();
var getPatientServices = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token, patientid) {
        var path, res, data;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    path = "".concat("https://api-auth.thrivelab.com/api", "/staff?patientId=").concat(patientid !== null && patientid !== void 0 ? patientid : null);
                    _ctx.next = 4;
                    return fetch(path, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(token)
                        }
                    });
                case 4:
                    res = _ctx.sent;
                    _ctx.next = 7;
                    return res.json();
                case 7:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.warn(_ctx.t0);
                    return _ctx.abrupt("return", undefined);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function getPatientServices(token, patientid) {
        return _ref.apply(this, arguments);
    };
}();
var getServices = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var token, serviceId, staffId, patientId, state, payor, utm_source, path, res, data;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    token = param.token, serviceId = param.serviceId, staffId = param.staffId, patientId = param.patientId, state = param.state, payor = param.payor, utm_source = param.utm_source;
                    _ctx.prev = 1;
                    path = "".concat("https://api-auth.thrivelab.com/api", "/staff?service=").concat(serviceId, "&staffId=").concat(staffId !== null && staffId !== void 0 ? staffId : "", "&patientId=").concat(patientId !== null && patientId !== void 0 ? patientId : "", "&state=").concat(state !== null && state !== void 0 ? state : "", "&payor=").concat(payor !== null && payor !== void 0 ? payor : "", "&utm_source=").concat(utm_source);
                    _ctx.next = 5;
                    return fetch(path, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(token)
                        }
                    });
                case 5:
                    res = _ctx.sent;
                    _ctx.next = 8;
                    return res.json();
                case 8:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](1);
                    console.warn(_ctx.t0);
                    return _ctx.abrupt("return", undefined);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                12
            ]
        ]);
    }));
    return function getServices(_) {
        return _ref.apply(this, arguments);
    };
}();
var getPatientInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token, email, patientId) {
        var path, res, data, patient, mailingStreet, mailingCity, mailingState, mailingCountry, mailingZip, gender, _$email, FirstName, LastName, phone;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    path = "".concat("https://api-auth.thrivelab.com/api", "/patient/").concat(email);
                    _ctx.next = 4;
                    return fetch(path, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(token)
                        }
                    });
                case 4:
                    res = _ctx.sent;
                    _ctx.next = 7;
                    return res.json();
                case 7:
                    data = _ctx.sent;
                    ;
                    if (data) {
                        mailingStreet = data.mailingStreet, mailingCity = data.mailingCity, mailingState = data.mailingState, mailingCountry = data.mailingCountry, mailingZip = data.mailingZip, gender = data.gender, _$email = data.email, FirstName = data.FirstName, LastName = data.LastName, phone = data.phone;
                        patient = {
                            first_name: FirstName,
                            last_name: LastName,
                            email: _$email,
                            phone: phone,
                            street: mailingStreet,
                            city: mailingCity,
                            gender: gender,
                            state: mailingState,
                            zip: mailingZip,
                            country: mailingCountry,
                            patientId: (data === null || data === void 0 ? void 0 : data.patientId) ? data === null || data === void 0 ? void 0 : data.patientId : (data === null || data === void 0 ? void 0 : data.patientId_long) ? data === null || data === void 0 ? void 0 : data.patientId_long : patientId !== null && patientId !== void 0 ? patientId : null
                        };
                    }
                    return _ctx.abrupt("return", patient !== null && patient !== void 0 ? patient : {
                        first_name: "",
                        last_name: "",
                        patientId: null
                    });
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    console.warn(_ctx.t0);
                    return _ctx.abrupt("return", {});
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function getPatientInfo(token, email, patientId) {
        return _ref.apply(this, arguments);
    };
}();
var getWorkspaces = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token) {
        var result;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("".concat("https://api-auth.thrivelab.com/api", "/staff/workspaces"), {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(token)
                        }
                    });
                case 2:
                    result = _ctx.sent;
                    _ctx.next = 5;
                    return result.json();
                case 5:
                    return _ctx.abrupt("return", _ctx.sent);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getWorkspaces(token) {
        return _ref.apply(this, arguments);
    };
}();
var getWorkspaceService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id, token) {
        var result;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("".concat("https://api-auth.thrivelab.com/api", "/staff/workspace-service?id=").concat(id), {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(token)
                        }
                    });
                case 2:
                    result = _ctx.sent;
                    _ctx.next = 5;
                    return result.json();
                case 5:
                    return _ctx.abrupt("return", _ctx.sent);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getWorkspaceService(id, token) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);